// ChatMessageBody.js — Rendu d'un contenu de message de chat : sticker Worms, gros emoji, ou texte.
// Utilisé par le chat communauté, les messages privés et le chat de groupe.
import React from 'react';
import WormSticker, { isSticker } from './WormSticker';
import { mediaUrl } from '../services/chatMedia';

// Détecte un message composé UNIQUEMENT d'emojis (1 à 6) → affichage agrandi (façon WhatsApp).
let EMOJI_ONLY = null;
try { EMOJI_ONLY = new RegExp('^(?:\\s*(?:\\p{Extended_Pictographic}|[\\u200D\\uFE0F\\u{1F3FB}-\\u{1F3FF}])\\s*){1,6}$', 'u'); }
catch { EMOJI_ONLY = null; }
export function isOnlyEmoji(text) {
  const t = String(text || '').trim();
  if (!t || t.length > 16 || !EMOJI_ONLY) return false;
  return EMOJI_ONLY.test(t);
}

// content peut être une chaîne JSON ou un objet ; renvoie le contenu + éventuels messages de CONTRÔLE
// (react/typing/seen) qui ne s'affichent pas comme des messages mais pilotent réactions/« écrit… »/vu.
export function parseContent(content) {
  let c = {};
  try { c = typeof content === 'string' ? JSON.parse(content) : (content || {}); } catch { c = {}; }
  return {
    text: c.message || '', sticker: c.sticker || null, audio: c.audio || null, gif: c.gif || null, premium: !!c.premium,
    react: c.react || null, ref: c.ref || null, typing: !!c.typing, seen: !!c.seen,
  };
}
// Un message de CONTRÔLE (réaction/typing/vu) ne doit jamais s'afficher dans le fil.
export function isControl(c) { return !!(c && (c.react || c.typing || c.seen)); }

export default function ChatMessageBody({ text, sticker, audio, gif }) {
  if (sticker && isSticker(sticker)) return <WormSticker id={sticker} size={84} />;
  if (audio) return <audio controls preload="none" src={mediaUrl(audio)} style={{ height: 34, maxWidth: 220 }} />;
  if (gif) return <img src={mediaUrl(gif)} alt="gif" style={{ maxWidth: 200, maxHeight: 200, borderRadius: 10 }} />;
  // Commande /me : « → action » stylée en italique (façon IRC/Discord).
  if (/^\/me\s+/.test(text || '')) return <i style={{ opacity: .85 }}>→ {text.replace(/^\/me\s+/, '')}</i>;
  if (isOnlyEmoji(text)) return <span style={{ fontSize: '2rem', lineHeight: 1.1 }}>{text}</span>;
  return <>{text}</>;
}
